module.exports = __webpack_public_path__ + "static/media/(000156).dd2dbdee.jpg";